import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { FEATURE_USER_SETTINGS } from '../store/constants';

const reducer = (state = initialState[FEATURE_USER_SETTINGS], action) => {
  switch (action.type) {
    case types.UPDATE_FEATURE_USER_SETTINGS: {
      const { payload } = action;
      return {
        ...state,
        ...payload
      };
    }
    case types.CLEAR_FEATURE_USER_SETTINGS:
      return initialState[FEATURE_USER_SETTINGS];
    default:
      return state;
  }
};

export default reducer;
